/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Compose_Preview_RefreshInputs */

const en_mail_compose_preview_refresh = /** @type {(inputs: Mail_Compose_Preview_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update preview`)
};

const de_mail_compose_preview_refresh = /** @type {(inputs: Mail_Compose_Preview_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau aktualisieren`)
};

/**
* | output |
* | --- |
* | "Update preview" |
*
* @param {Mail_Compose_Preview_RefreshInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_preview_refresh = /** @type {((inputs?: Mail_Compose_Preview_RefreshInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_Preview_RefreshInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_preview_refresh(inputs)
	return en_mail_compose_preview_refresh(inputs)
});